/* Do not edit these strings. They are generated by ptmessages.js.php */
ptMessages = {
    "partnerdownloadbookmark": "Hai gi\u00e0 creato un segnalibro per questa pagina? Premere <CTRL> + D per aggiungerla ai preferiti.",
    "applyunload": "Non hai ancora inviato la richiesta completa per la prova gratuita.",
    "equaltocaseinsensitivemsg": "Inserire nuovamente lo stesso valore.",
    "distanceunitmiles": "Miglia",
    "distanceunitkilometers": "Chilometri",
    "distanceperyearlabel": " all'anno",
    "hours": "ore",
    "priceinterval3": "(pagamento trimestrale)",
    "priceinterval12": "(pagamento annuale)",
    "priceinterval36": "(pagamento ogni 36 mesi)",
    "enterprise": "Azienda",
    "enthintbuymore": "A partire da 2 licenze agente:",
    "enthintusermgmt": "Gestione centralizzata degli utenti",
    "enthintrights": "Gestione delle autorizzazioni",
    "enthintorgsettings": "Impostazioni aziendali",
    "enthintapi": "Importazione ed esportazione di dati via API",
    "enthintodata": "Analisi dei dati via Excel e OData",
    "enthintadmins": "Account amministratori gratuiti",
    "shopbuysub": "a {invoiceamountinclvat} ogni {billinginterval} mesi fino al termine del contratto",
    "shopvatsub": "L'importo \u00e8 comprensivo dell'IVA al {vatrate}% ({vatamount}).<br\/>Questa sar\u00e0 indicata sulla fattura.",
    "shopprice": "Prezzo",
    "shoppriceincurrency": "Prezzo in {currency}",
    "shopcurrencysub": "Tutti i prezzi in {currency}",
    "shopvatnotapplicable": "Si applica in fattura un'IVA del {vatrate}% pari a {vatamount}.",
    "shopordersumvatsub": "{totalincl} comprensivo dell'IVA al {vatrate}%",
    "shopmindatevalidate": "La data deve essere uguale o superiore a {2}.",
    "enthintbuyevenmore": "A partire da 10 licenze agente:",
    "enthintusergroups": "Gruppi utenti",
    "etrackerstatus": "Stato:",
    "etrackeractive": "etracker \u00e8 attivato.",
    "etrackerinactive": "etracker \u00e8 disattivato.",
    "etrackeroptin": "Attivare etracker",
    "etrackeroptout": "Disattivare etracker",
    "brPhoneErrorMessage": "Inserisci un numero di telefono valido (10 o pi\u00f9 cifre)",
    "integererror": "Inserisci solo numeri interi",
    "initvatnrlabel": "Partita IVA comunitaria",
    "ptSimpleForm_date": "Selezionare solo i giorni lavorativi",
    "ptSimpleForm_mindate": "La data deve essere compresa tra {calculatedMinDate}",
    "ptSimpleForm_noWeekends": "Selezionare solo i giorni lavorativi",
    "ibanErrorMessage": "Inserisca un IBAN valido"
};
